export enum SEOOptions {
    robots = 'robots',
    sitemap = 'sitemap',
    redirects = 'redirects',
    seoPages = 'pages',
}
